import styled from 'styled-components';

export const UploadedEvidenceContainer = styled.div`
  padding: 20px;
`;
